import { useEffect, DependencyList } from 'react'

export function useDebounceEffect(
  fn: () => void,
  waitTime: number,
  deps: DependencyList,
) {
  useEffect(() => {
    const t = setTimeout(() => {
      // fn.apply(undefined, deps)
      // fn(...deps);
      fn(...(deps as [])); // Explicitly cast to tuple type

    }, waitTime)

    return () => {
      clearTimeout(t)
    }
  }, deps)
}
